import { Slider } from "@material-ui/core";
import styled from "styled-components";
const styles = {
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '10px',
  },
  dropdown: {
    flex: '1 1 46%',
    marginBottom: '15px',
  },
  dropdownProvider: {
    flex: '1 1 auto',
    marginBottom: '15px',
    width:'100%'
  },
  message: {
    flex: '1 1 100%',
    margin: 0,
    fontSize: '1.5em',
    textAlign: 'center',
    lineHeight: 1.5,
  },
  messageSmall: {
    fontSize: '1em',
  },
  sliderTopMessage:{
    '& .MuiSlider-valueLabel': {
      color: "red",
    },
  }
};
const StyledSlider = styled(Slider)`
  .MuiSlider-valueLabel {
    background: #808080;
    color: #808080;
    left:0px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .MuiSlider-valueLabel > span span {
    color:#fff;
  }
`;

export {styles, StyledSlider};